module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"kpiAchievements":"KPI実績","actual":"本年実績","lastYear":"比較期間実績","YoY":"対比％"}}')
  delete Component.options._Ctor
}
